<template>
  <div class="col-12">
    <Search
      :allowFields="$lang.azmoon_execute_fildes"
      :hiddenFields="hiddenFields"
      :allowCollapse="false"
      :url="azmoon_execute_url"
      :title="$lang.azmoon_execute"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="true"
      :extraButtons="extraButtons"
      :dynamicButtons="availableButtons"
      :isLoading="isLoading"
      ref="azmoonExecuteSearch"
      :showPaginationTop="true"
      :remove_item="handleRemove"
      @getPermisson="getPermisson"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <b-card>
          <div slot="header">
            <strong v-text="$lang.add_azmoon_execute" />
          </div>
          <AddAzmoonExecute @handleBack="search.close" @getItems="getItems" />
        </b-card>
      </template>
    </Search>

    <Confirm
      :title="confirmTitle"
      :description="message"
      :loading="changeStateLoading"
      :loadingSpinnerText="$lang.updating_data"
      v-model="state"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="changeState"
      @cancel="notChangeState"
    />
    <Confirm
      v-model="confirmData.show"
      :title="confirmData.title"
      :description="confirmData.description"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      :loading="confirmData.loading"
      :loadingSpinnerText="$lang.updating_data"
      dynamicClass=""
      @ok="rebuildReport"
      @cancel="confirmData.show = false"
    />
    <Confirm
      v-model="isRebuildAllReports"
      :title="$lang.rebuildAllReports"
      :description="$lang.areYouSureRebuildAllReports"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      :loading="isRebuildAllReportsLoading"
      :loadingSpinnerText="$lang.checking_data"
      dynamicClass=""
      @ok="handleRebuildAllReports"
      @cancel="isRebuildAllReports = false"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddAzmoonExecute from "./addAzmoonExecute";
import Confirm from "@/components/base/confirm";
import { pathOr, includes } from "ramda";
import {
  isAdmin,
  generateApiUrl,
  toastAlert,
  generateError,
} from "@/shared/utils";

export default {
  name: "search-azmoon-execute",
  components: {
    Search,
    Confirm,
    AddAzmoonExecute,
  },
  inject: ["azmoonExecuteRepository"],
  data() {
    return {
      state: false,
      confirmTitle: "",
      message: "",
      permissions: [],
      changeStateItem: null,
      isLoading: false,
      hiddenFields: [
        "created_at.jalali",
        "created_by",
        "center_execute_id",
        "company.name",
      ],
      changeStateLoading: false,
      confirmData: {
        loading: false,
        show: false,
        title: this.$lang.reportConfirmTitle,
        description: this.$lang.are_you_sure,
        code: null,
      },
      isRebuildAllReports: false,
      isRebuildAllReportsLoading: false,
    };
  },
  computed: {
    azmoon_execute_url() {
      return generateApiUrl(["azmoon", "azmoon_execute"]);
    },
    extraButtons() {
      return [
        {
          name: "rebuildAllReports",
          condition: true,
          title: this.$lang.rebuildAllReports,
          click: this.handleOpenRebuildAllReportsModal,
          iconName: "file-sync-outline",
        },
      ];
    },
  },
  methods: {
    isAdmin,
    generateApiUrl,
    availableButtons(item) {
      const buttons_azmoon_execute = [
        {
          id: "0",
          name: "edit",
          click: this.azmoon_execute,
        },
        {
          id: "1",
          name: "editView",
          click: this.azmoon_execute,
        },
        {
          id: "2",
          name: "view",
          click: this.azmoon_execute,
        },
        {
          id: "3",
          name: "play_azmoon_execute",
          click: this.playAzmoonExecute,
          iconFont: "fas fa-file-invoice fa-lg text-success",
          text: this.$lang.playAzmoonExecute,
        },
        {
          id: "5",
          name: "delete",
        },
        {
          name: "excelExport",
          text: this.$lang.reportConfirmTitle,
          click: this.showConfirm,
        },
      ];
      const buttons = {
        1: [
          ...buttons_azmoon_execute.filter((button) =>
            includes(button.name, [
              "edit",
              "view",
              "play_azmoon_execute",
              "delete",
            ])
          ),
        ],
        2: [
          ...buttons_azmoon_execute.filter((button) =>
            includes(button.name, [
              "edit",
              "view",
              "play_azmoon_execute",
              "excelExport",
            ])
          ),
        ],
        3: [
          ...buttons_azmoon_execute.filter((button) =>
            includes(button.name, ["editView", "excelExport"])
          ),
        ],
      };

      let key = pathOr(null, ["status", "id"], item);
      const centerExecuteId = pathOr(null, ["center_execute_id"], item);
      if (centerExecuteId) {
        // اگر آزمون از طریق کانون ساخته شود امکان حذف و ویرایش ندارد
        key = 3;
      }
      return pathOr([], [key], buttons);
    },
    async changeState() {
      try {
        this.changeStateLoading = true;
        let payload = {
          status: 2,
        };
        const response = await this.azmoonExecuteRepository.partial_edit(
          this.changeStateItem.id,
          payload
        );
        this.$notify.success(response.data.message);
        this.notChangeState();
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.changeStateLoading = false;
      }
    },
    notChangeState() {
      this.changeStateItem = null;
      this.message = "";
      this.state = false;
    },
    async playAzmoonExecute(item) {
      this.changeStateItem = item;
      this.message = this.$lang.playAzmoonExecuteTooltip;
      this.confirmTitle = this.$lang.playAzmoonExecute;
      this.state = true;
    },
    azmoon_execute(item) {
      this.$router.push({
        name: "edit_azmoon_execute",
        params: {
          id: item.id,
        },
      });
    },
    handleBack(getItems = true, callback) {
      callback();
      getItems && this.getItems();
    },
    getItems() {
      this.$refs.azmoonExecuteSearch.getItems();
    },
    getPermisson(permissions) {
      this.permissions = permissions;
    },
    showConfirm(item) {
      const hasWave = pathOr(false, ["has_wave"], item);
      if (hasWave) {
        toastAlert(this.$lang.waveReportMessage, "warning");
      }
      this.confirmData.code = pathOr(null, ["code"], item);
      this.confirmData.show = true;
    },
    async rebuildReport() {
      try {
        this.confirmData.loading = true;
        const url = generateApiUrl(["azmoon", "rebuildReport"]);
        const payload = {
          resource: "azmoon_execute",
          resource_code: this.confirmData.code,
          report_name: "azmoon_public",
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.confirmData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
    async handleRemove(item) {
      const code = pathOr(null, ["code"], item);
      try {
        const url = generateApiUrl(["azmoon", "azmoon_execute_id"], [code]);
        const response = await this.$httpService.delete(url);
      } catch (error) {
        this.$generateError(error);
      }
    },
    handleOpenRebuildAllReportsModal() {
      this.isRebuildAllReports = true;
    },
    async handleRebuildAllReports() {
      try {
        this.isRebuildAllReportsLoading = true;
        const url = generateApiUrl(["azmoon", "rebuildAllAzmoonReports"]);
        const response = await this.$httpService.patch(url);
        toastAlert(response.data.message);
        this.isRebuildAllReports = false;
      } catch (error) {
        generateError(error);
      } finally {
        this.isRebuildAllReportsLoading = false;
      }
    },
  },
};
</script>
